import { useState } from 'react'
import { useQueryClient } from 'react-query'
import { useMutateAuth } from './useMutateAuth'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { resetContactState, setContactFilterType } from '../../../slices/contactAddressSlice'


export const useProcessAuth = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  // const [loginUserId, setLoginUserId] = useState('WFCV2301170002')
  // const [password, setPassword] = useState('N/A')
  // const [loginUserId, setLoginUserId] = useState('WFCV2301170005')
  // const [password, setPassword] = useState('N/A')
  // const [loginUserId, setLoginUserId] = useState('WFCV2303270003')
  // const [password, setPassword] = useState('N/A')
  const [loginUserId, setLoginUserId] = useState('')
  const [password, setPassword] = useState('')

  const queryClient = useQueryClient()
  const { loginMutation, logoutMutation } = useMutateAuth()

  const loginAuth = async (
    e: React.FormEvent<HTMLFormElement>,
  ) => {
    e.preventDefault()
    loginMutation.mutate({
      login_user_id: loginUserId,
      password: password,
    }, {
      onSuccess: () => {
        dispatch(resetContactState())
        navigate('/contacts')
      }
    }
    )
  }

  const logoutAuth = async (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    e.preventDefault()
    await logoutMutation.mutateAsync()
    dispatch(setContactFilterType(""))
    // queryClient.removeQueries('contactAddress')
    // queryClient.removeQueries('user')
    queryClient.removeQueries('csrfToken')
    queryClient.removeQueries('loggedInUser')
    queryClient.removeQueries('contactGroups')
    queryClient.removeQueries('contactAddresses')
    navigate('/login')
  }

  return {
    loginUserId,
    setLoginUserId,
    password,
    setPassword,
    loginAuth,
    logoutAuth,
    loginMutation,
  }
}
